import React, { useState, useEffect, useMemo } from 'react';
import './App.css';
import { Excalidraw, exportToCanvas, exportToBlob } from "@excalidraw/excalidraw";
import Footer from "./Footer";

let theExcalidrawAPI = null;

const resolvablePromise = () => {
  let resolve;
  let reject;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  promise.resolve = resolve;
  promise.reject = reject;
  return promise;
};

function App() {
  const [height, setHeight] = useState(window.innerHeight);

  const updateHeight = () => {
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateHeight);
    // Clean up listener on component unmount
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  const UIOptions = {
    canvasActions: {
      changeViewBackgroundColor: false,
      clearCanvas: false,
      loadScene: false,
      saveAsImage: true,
    },
  };

  const [canvasUrl, setCanvasUrl] = useState("");
  const [excalidrawAPI, setExcalidrawAPI] = useState(null);

  const excalidrawRef = useMemo(
    () => ({
      current: {
        readyPromise: resolvablePromise(),
      },
    }),
    [],
  );

  useEffect(() => {
    excalidrawRef.current.readyPromise.then((api) => {
      theExcalidrawAPI = api;
    });
  }, [excalidrawRef]);

  return (
    <>
      <div style={{ height: height }}>
        <Excalidraw 
          ref={excalidrawRef}
          UIOptions={UIOptions} />
          <Footer reference={excalidrawRef}></Footer>
      </div>
    </>
  );
}

export default App;
